import { render, staticRenderFns } from "./ProductionSubparts.vue?vue&type=template&id=00b97fc0&scoped=true&"
import script from "./ProductionSubparts.vue?vue&type=script&lang=js&"
export * from "./ProductionSubparts.vue?vue&type=script&lang=js&"
import style0 from "./ProductionSubparts.vue?vue&type=style&index=0&id=00b97fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b97fc0",
  null
  
)

export default component.exports